import { Component } from '@angular/core';
import { IconsModule } from '../../icons/icons.module';
import { NgClass, NgFor, NgIf } from '@angular/common';
import {
  expandOnEnterAnimation,
  collapseOnLeaveAnimation,
} from 'angular-animations';

@Component({
  selector: 'faq',
  standalone: true,
  imports: [IconsModule, NgFor, NgIf, NgClass],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  animations: [
    expandOnEnterAnimation({ duration: 400 }),
    collapseOnLeaveAnimation({ duration: 400 }),
  ],
})
export class FaqComponent {
  faqs: { question: string; answer: string; showAnswer: boolean }[] = [
    {
      question: 'What is an AI-powered education platform?',
      answer:
        'It is a smart learning system that uses artificial intelligence to individualize learning, track progress, and provide real-time support to students and teachers',
      showAnswer: true,
    },
    {
      question: 'How does AI improve the learning experience?',
      answer:
        'AI identifies learning gaps, recommends the right content, adjusts difficulty levels, and helps students learn faster with targeted guidance.',
      showAnswer: false,
    },
    {
      question: 'Can Atomo AI Classroom function in no/low network zone?',
      answer:
        'Yes. Our patented ‘Concat’ device ensures that the classroom functions seamlessly even when there is low/no network.',
      showAnswer: false,
    },
    {
      question: 'Can ‘Concat’ device be connected to projector/IFP?',
      answer:
        'Yes. Concat devices can be easily connected (plug-and-play) into any projector/IFP.',
      showAnswer: false,
    },
    {
      question: 'In how many classrooms is Atomo deployed in, as of now?',
      answer:
        'Present there are 5100+ Atomo classrooms across India. This is a steadily growing number',
      showAnswer: false,
    },
    {
      question:
        'Can Atomo Super App be integrated into/with existing school/institute hardware?',
      answer:
        'Yes. It can be easily integrated into the existing school/institute .',
      showAnswer: false,
    },
    {
      question:
        'Is this platform suitable for schools, teachers, and coaching centers?',
      answer:
        'Yes. The platform is designed for individual learners as well as institutions, offering tools for teachers, administrators, and students.',
      showAnswer: false,
    },
  ];

  toggleAnswer(index: number): void {
    this.faqs.forEach((faq, i) => {
      if (i !== index) {
        faq.showAnswer = false;
      }
    });
    this.faqs[index].showAnswer = !this.faqs[index].showAnswer;
  }
}
